import { Container } from 'components/Container';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsSidebar } from 'modules/cms/components/Sidebar';
import { CmsSidebarBlockComponent } from 'modules/cms/components/SidebarBlockComponent';

type Props = {
  content: CmsApiPage;
};

export function CmsUpperSidebar({ content }: Props) {
  return (
    <CmsSidebar>
      {content.sidebar.contentBlocksTop.map((block, index) => (
        <Container key={block.id}>
          <CmsSidebarBlockComponent
            content={content}
            block={block}
            index={index}
          />
        </Container>
      ))}
    </CmsSidebar>
  );
}
